export default "__VITE_ASSET__f1ea23f5__"